// FILE: src/services/email/emailAnalyticsService.js
//
// Read-only client wrapper over the admin lifecycle-email analytics RPCs
// (migration 068). Every RPC enforces _is_caller_admin() server-side, so a
// non-admin caller receives an error and null is returned here. Omitted filter
// args fall back to the SQL defaults (last 30 days, no journey/cert filter).

import { supabase } from '../supabaseClient';

function buildArgs({ from, to, journey, examId, status, limit } = {}) {
  const a = {};
  if (from) a.p_from = from;
  if (to) a.p_to = to;
  if (journey) a.p_journey = journey;
  if (examId) a.p_exam_id = examId;
  if (status) a.p_status = status;
  if (limit) a.p_limit = limit;
  return a;
}

async function call(fn, args) {
  try {
    const { data, error } = await supabase.rpc(fn, args);
    if (error) {
      console.warn(`[emailAnalyticsService] ${fn} failed:`, error.message);
      return null;
    }
    return data;
  } catch (err) {
    console.warn(`[emailAnalyticsService] ${fn} unexpected error:`, err?.message || err);
    return null;
  }
}

/** Aggregate metrics: status/journey/day counts, delivery, retry, suppression. */
export function fetchEmailMetrics(opts = {}) {
  const { from, to, journey, examId } = opts;
  return call('admin_email_metrics', buildArgs({ from, to, journey, examId }));
}

/** Recent failed/suppressed jobs with sanitized failure reasons. */
export function fetchEmailRecentFailures(opts = {}) {
  const { limit, journey } = opts;
  return call('admin_email_recent_failures', buildArgs({ limit, journey }));
}

/** Filtered job list (journey / cert / status / date range). */
export function fetchEmailJobs(opts = {}) {
  return call('admin_email_jobs', buildArgs(opts));
}
